"use client";

import React, { useEffect, useState } from "react";
import EventSlider from "./EventSlider";
import {
    EventBannerResponse,
    PromotionBannerResponse,
    SubPromotionBanner,
} from "@/services/dataTypes";
import "../../shared/CompanyMainBanner/companybanner.css";

interface Props {
    domain: string;
    banners:
    | EventBannerResponse[]
    | PromotionBannerResponse[]
    | SubPromotionBanner[];
    eventName: string;
}

const EventBanner = ({ domain, banners, eventName }: Props) => {
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        setHydrated(true);
    }, []);

    return (
        <div className="w-full overflow-hidden rounded-t-xl border border-gray-200 bg-white">
            <div
                className="slider-hydration-wrapper"
                style={{
                    position: "relative",
                    maxWidth: "100%",
                }}
            >
                <div
                    className="hydrated-slider"
                    style={{
                        opacity: hydrated ? 1 : 0,
                        transition: "opacity 0.3s ease",
                    }}
                >
                    <EventSlider
                        sliders={banners}
                        domain={domain}
                        eventName={eventName}
                    />
                </div>
            </div>
        </div>
    );
};

export default EventBanner;